import { config } from '@hotwired/turbo'
import { confirmationOptions, requestConfirmation } from './confirmation'

// Structured messages travel with Turbo's temporary link forms; custom data
// attributes on the original link do not. Plain confirmation strings still work.
export function confirmTurbo(message: string, form: HTMLFormElement, submitter?: HTMLElement) {
  let options = { ...confirmationOptions(form), ...Object.fromEntries(
    Object.entries(confirmationOptions(submitter)).filter(([, value]) => value !== undefined)
  ) }
  if (message.startsWith('confirmation:')) {
    const payload = JSON.parse(message.slice('confirmation:'.length))
    message = payload.message
    options = { ...options, ...payload }
  }
  return requestConfirmation(message, { ...options, form })
}

config.forms.confirm = confirmTurbo
